import { callAuthorizedGraphQLEndpoint } from '../../Module/graphQL'

const getClientReferralProgramByCampaignId = campaignId => {
  const query = `
    query ($campaignId:ID!) {
        campaign(id:$campaignId){
           clientReferralProgram{
               id
               campaignId
               npsEmailDate
               referralEmailDate
               score
               feedback
           }
        }
      }
  `
  return callAuthorizedGraphQLEndpoint(query, { campaignId })
}

const updateClientReferralProgramByCampaignId = input => {
  const query = `
    mutation ($input: UpdateClientReferralProgramInput!) {
        updateClientReferralProgram(input:$input){
               id
               campaignId
               npsEmailDate
               referralEmailDate
               score
               voterId
               feedback
        }
      }
  `
  return callAuthorizedGraphQLEndpoint(query, { input })
}

export {
  getClientReferralProgramByCampaignId,
  updateClientReferralProgramByCampaignId,
}
